import {Platform} from 'react-native';
import DeviceInfo from 'react-native-device-info';

/**
 * Get auth headers.
 */
export const getHeaders = async (): Promise<any> => {
  // const fcmToken = await getFcmToken();
  const manufacturer = await DeviceInfo.getManufacturer();
  const uniqueId =
    Platform.OS === 'ios'
      ? await DeviceInfo.getUniqueId()
      : DeviceInfo.getAndroidIdSync();
  const deviceName = await DeviceInfo.getDeviceName();

  return {
    'X-Device-OS': Platform.OS,
    'X-Device-OS-Version': DeviceInfo.getSystemVersion(),
    'X-Device-Manufacturer': manufacturer,
    'X-Device-Model': DeviceInfo.getModel(),
    // 'X-Device-FCM-Token': fcmToken,
    'X-Device-App-Version': DeviceInfo.getBuildNumber(),
    'X-Device-UDID': uniqueId,
    'X-Device-Name': deviceName,
    'X-Device-OS-Name': DeviceInfo.getSystemName(),
    'X-Device-Platform': Platform.OS,
  };
};
